import { Menu } from '@mantine/core';
import { apiQueryKey, fetchApiDeleteBiMetric } from '@repo/api-codegen';
import { Icon, IconButton } from '@repo/foundations';
import { useCallback } from 'react';
import { queryClient, useAuthUser } from '../../../api';
import { openDeleteConfirmModal } from '../../../components/ModalManager';

interface ActionMenuProps {
	openLineageModal: () => void;
	metricName: string;
	metricId: string;
	numDashboards: number;
	onDelete: () => void;
}

export function ActionMenu({
	openLineageModal,
	metricName,
	metricId,
	numDashboards,
	onDelete,
}: ActionMenuProps) {
	const { isAdminUser } = useAuthUser();

	const handleDelete = useCallback(async () => {
		openDeleteConfirmModal({
			title: `Delete "${metricName}" metric?`,
			description: `This metric will be removed from ${numDashboards} dashboards. This can't be undone.`,
			onConfirm: async () => {
				await fetchApiDeleteBiMetric({
					pathParams: { biMetricId: metricId },
				});

				queryClient.invalidateQueries({
					queryKey: apiQueryKey('intelligence/bi_dashboards'),
				});

				onDelete();
			},
		});
	}, [metricId, metricName, onDelete, numDashboards]);

	return (
		<Menu>
			<Menu.Target>
				<IconButton variant="tertiary" iconName="dots" tooltip="More actions" />
			</Menu.Target>
			<Menu.Dropdown>
				<Menu.Item icon={<Icon name="map" />} onClick={openLineageModal}>
					View lineage
				</Menu.Item>
				{isAdminUser && (
					<Menu.Item
						icon={<Icon name="trash" />}
						onClick={handleDelete}
						color="red"
					>
						Delete...
					</Menu.Item>
				)}
			</Menu.Dropdown>
		</Menu>
	);
}
